import { gql } from "@apollo/client"
export const ADD_VEHICLE_EXPENSE = gql`
  mutation CreateVehicleExpense(
    $borneBy: String
    $contractId: ID!
    $expenseFor: ID!
    $expenseTypeId: ID!
    $name: String
    $netAmount: Float!
    $quantity: Float!
    $quantityRate: Float!
    $remark: String
    $resourceUsed: Int
  ) {
    addVehicleExpense(
      borneBy: $borneBy
      contractId: $contractId
      expenseFor: $expenseFor
      expenseTypeId: $expenseTypeId
      name: $name
      netAmount: $netAmount
      quantity: $quantity
      quantityRate: $quantityRate
      remark: $remark
      resourceUsed: $resourceUsed
    ) {
      expense {
        id
        borneBy
        netAmount
        quantity
        quantityRate
        expenseType {
          id
          name
        }
        remark
        resourceUsed
        contract {
          id
          number
        }
      }
    }
  }
`

export const ADD_VEHICLE_PAYMENT = gql`
  mutation MakeVehiclePayment(
    $amount: Float!
    $contractId: ID!
    $name: String
    $paidToId: ID!
    $paymentFor: ID!
    $paymentTypeId: ID!
    $remark: String
    $transactionType: String
  ) {
    addVehiclePayment(
      name: $name
      amount: $amount
      paymentTypeId: $paymentTypeId
      paidToId: $paidToId # vehicleDriver or vehicleOwner
      contractId: $contractId # currentContractId
      remark: $remark
      transactionType: $transactionType
      paymentFor: $paymentFor #VehicleId
    ) {
      payment {
        id
        name
        amount
        paidTo {
          id
          fullName
        }
        contract {
          id
        }
        remark
        paymentType {
          id
          name
        }
        transactionType
      }
    }
  }
`
